import React, { useContext, useEffect, useState } from 'react'
import NewButton from '../../../../NewComponents/NewButton'
import { useScreenTransition } from '../../../../Hooks/useScreenTransition';
import { firestore } from '../../../../firebase.config';
import { DataContext } from '../../../../Context/DataContext';
import { options } from './Ques1';
import LOGO from "../../../../assets/logo.png";


const Screen5 = () => {
    const { transitionTo } = useScreenTransition();
    const {userData, teamData} = useContext(DataContext);
    const [finalText, setFinalText] = useState("");

    const contineToDashboard = () => {
        firestore.collection("teams").doc(userData.teamId)
        .update({newTeam: false, onBoarding: {...teamData.onBoarding, onboarding_completed: true}})
        .then(() => {
            transitionTo("/account/team-members");
        })
    }

    useEffect(() => {
        if(userData && userData.teamId && teamData){
          const onBoarding = teamData.onBoarding;

          if(!onBoarding || !onBoarding.translation_workflow){
            transitionTo(`/account/onboarding?step=1`);
            return;
          }
          if(!onBoarding || !onBoarding.immigration_platforms){
            transitionTo(`/account/onboarding?step=2`);
            return;
          }
          if(!onBoarding || !onBoarding.team_size){
            transitionTo(`/account/onboarding?step=3`);
            return;
          }

          if(onBoarding && onBoarding.translation_workflow){
            setFinalText(options.find(option => option.value === onBoarding.translation_workflow).finalText);
          }else{
            transitionTo("/account/onboarding?step=1");
          }
        }
      }, [userData, teamData])

  return (
    <div className="flex flex-[1] flex-col justify-center items-center">
          <img
              src={LOGO}
              alt="Logo eVerbary"
              className="h-10 w-auto cursor-pointer absolute top-[20px] left-[40px]"
            />
        <div className=" shadow-md w-full max-w-[370px] flex flex-col justify-center items-start gap-[32px] bg-[#fff] rounded-[16px] h-max p-[32px]">
              <h2 className="onBoarding-title">You’re all set! ✨</h2>
              <p className="onBoarding-description">
                {finalText}
              </p>
              <NewButton text="Continue to Dashboard" icon={false} onClick={contineToDashboard} width='100%'/>
            </div>
        </div>
  )
}

export default Screen5